var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.multipleLimit')}},[_c('el-input-number',{staticClass:"hide-spin-button",staticStyle:{"width":"100%"},attrs:{"min":0},model:{value:(_vm.optionModel.multipleLimit),callback:function ($$v) {_vm.$set(_vm.optionModel, "multipleLimit", $$v)},expression:"optionModel.multipleLimit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }